/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import DateSelector from '../../components/DateSelector';
import { IMonthValue, getPreviousMonth, getQStart, formatYearValue, formatDateMMYYYY, formatQValue, getEndOfYearMonthValue, getEndOfQMonthValue } from '../../util/DateUtils';

interface DateSelectionProps {
  intl: any;
  header: string;
  cssclass: string;
  click: (header: string, start: IMonthValue, end: IMonthValue) => void;
}

const DateSelection = (props: DateSelectionProps) => {

  const [startDate, setStartDate] = useState(getPreviousMonth());
  const [endDate, setEndDate] = useState(getPreviousMonth());
  const [curStart, setCurStart] = useState(getPreviousMonth());
  const [curEnd, setCurEnd] = useState(getPreviousMonth());
  const [curYear, setCurYear] = useState(getPreviousMonth());
  const [curEndYear, setCurEndYear] = useState(getPreviousMonth());
  const [curQ, setCurQ] = useState(getQStart(getPreviousMonth()));
  const [curEndQ, setCurEndQ] = useState(getQStart(getPreviousMonth()));
  const [curPrev, setCurPrev] = useState(getPreviousMonth());
  const [rangeType, setRangeType] = useState('month');
  const [header, setHeader] = useState('');

  useEffect(() => {
    setCurrentDate(rangeType);
  }, [rangeType]);

  useEffect(() => {
    formatHeader(rangeType);
  }, [startDate, endDate]);

  const handleRadioChange = (e: any) => {
    setRangeType(e.target.value);
  }

  const setCurrentDate = (type: string) => {
    if(type==='month') {
      setStartDate(curStart);
      setEndDate(curEnd);
    } else if (type==='year') {
      setStartDate(curYear);
      setEndDate(curEndYear);
    } else if (type==='q') {
      setStartDate(curQ);
      setEndDate({year: curEndQ.year, month: curEndQ.month+2});
    } else if (type==='prevyear') {
      setStartDate({year: curPrev.year-1, month: curPrev.month});
      setEndDate(curPrev);
    }
    formatHeader(type);
  }

  const formatHeader = (type: string) => {
    if(type==='month') {
      setHeader(formatDateMMYYYY(startDate) + " - " + formatDateMMYYYY(endDate))
    } else if (type==='year') {
      setHeader(formatYearValue(startDate.year) + " - " + formatYearValue(endDate.year));
    } else if (type==='q') {
      setHeader(formatQValue(startDate) + " - " + formatQValue(endDate));
    } else if (type==='prevyear') {
      setHeader(formatDateMMYYYY(startDate) + " - " + formatDateMMYYYY(endDate));
    }
  }

  return (
    <div className={ props.cssclass }>
      <h4><FormattedMessage id={ props.header }/></h4>
      <div className="radio-value">
        <Form.Group>
          <input
            type="radio"
            value="month"
            checked={rangeType === 'month'}
            onChange={handleRadioChange}
          />
          <label><FormattedMessage id="comparereports.month"/></label>
        </Form.Group>
        <Form.Group>
          <DateSelector
            startPeriod={curStart}
            endPeriod={curEnd}
            disabled={ rangeType !== 'month' }
            onChange={(start: IMonthValue, end: IMonthValue) => {
              setStartDate(start);
              setCurStart(start);
              setEndDate(end);
              setCurEnd(end);
            } } dateFormat={'yyyy-MM'} isStartAndEnd={true} />
        </Form.Group>
      </div>
      <div className="radio-value">
        <Form.Group>
          <input
            type="radio"
            value="year"
            checked={rangeType === 'year'}
            onChange={handleRadioChange}
          />
          <label><FormattedMessage id="comparereports.year"/></label>
        </Form.Group>
        <Form.Group>
          <DateSelector
            startPeriod={curYear}
            endPeriod={curEndYear}
            disabled={rangeType !== 'year'}
            onChange={(start: IMonthValue, end: IMonthValue) => {
              setStartDate(start);
              setCurYear(start);
              setEndDate(getEndOfYearMonthValue(end));
              setCurEndYear(getEndOfYearMonthValue(end));
            } } dateFormat={'yyyy'} isStartAndEnd={true} />
        </Form.Group>
      </div>
      <div className="radio-value">
        <Form.Group>
          <input
            type="radio"
            value="q"
            checked={rangeType === 'q'}
            onChange={handleRadioChange}
          />
          <label><FormattedMessage id="comparereports.q"/></label>
        </Form.Group>
        <Form.Group>
          <DateSelector
            startPeriod={curQ}
            endPeriod={curEndQ}
            disabled={rangeType !== 'q'}
            onChange={(start: IMonthValue, end: IMonthValue) => {
              setStartDate(start);
              setCurQ(start);
              setEndDate(getEndOfQMonthValue(end));
              setCurEndQ(getEndOfQMonthValue(end));
            } } dateFormat={'yyyy, QQQ'} isStartAndEnd={true} />
        </Form.Group>
      </div>
      <div className="radio-value">
        <Form.Group>
          <input
            type="radio"
            value="prevyear"
            checked={rangeType === 'prevyear'}
            onChange={handleRadioChange}
          />
          <label><FormattedMessage id="comparereports.prevyear"/></label>
        </Form.Group>
        <Form.Group>
          <DateSelector
            startPeriod={curPrev}
            disabled={ rangeType !== 'prevyear' }
            onChange={(start: IMonthValue) => {
              setStartDate({ year: start.year - 1, month: start.month });
              setEndDate(start);
              setCurPrev(start);
            } } dateFormat={'yyyy-MM'}/>
        </Form.Group>

      </div>
      <div className="action-buttons">
        <button
          className="small-save-button btn btn-primary"
          onClick={() => {
            props.click(header, startDate, endDate);
          }}
          ><FormattedMessage id="comparereports.get"/>
        </button>
      </div>
  </div>);
}

export default injectIntl(DateSelection);
